import Alpine from 'alpinejs';

import { debug } from './components/debug';
import { accordion } from './components/accordion';
import { collapse } from './components/collapse';
import { sliders } from './components/sliders';
import { clickable } from './components/clickable';
import { matchHeight } from './components/matchHeight';
import { mobileMenu } from './components/mobileMenu';
import { sidebarFilters } from './components/sidebarFilters';
import { stickyHeader } from './components/stickyHeader';

document.addEventListener('DOMContentLoaded', () => {
  window.Alpine = Alpine;

  Alpine.start();

  // Application code.
  collapse();
  matchHeight();
  clickable();
});

// debug();
accordion();
sliders();
mobileMenu();
sidebarFilters();
stickyHeader();
